module.exports = __webpack_public_path__ + "static/tiktok-01e8fec784293a1a09ba894fb2a62c60.png";